{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
  "title": "CredentialConfigCreate",
  "type": "object",
  "properties": {
    "embeddedDisclosurePolicy": {
      "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
      "oneOf": [
        {
          "$ref": "./AttestationBasedPolicy.schema.json"
        },
        {
          "$ref": "./NoneTrustPolicy.schema.json"
        },
        {
          "$ref": "./AllowListPolicy.schema.json"
        },
        {
          "$ref": "./RootOfTrustPolicy.schema.json"
        }
      ],
      "allOf": [
        {
          "$ref": "./EmbeddedDisclosurePolicy.schema.json"
        }
      ]
    },
    "id": {
      "type": "string"
    },
    "description": {
      "type": "string"
    },
    "config": {
      "$ref": "./IssuerMetadataCredentialConfig.schema.json"
    },
    "claims": {
      "type": "object"
    },
    "claimsWebhook": {
      "description": "Webhook to receive claims for the issuance process.",
      "allOf": [
        {
          "$ref": "./WebhookConfig.schema.json"
        }
      ]
    },
    "notificationWebhook": {
      "description": "Webhook to receive claims for the issuance process.",
      "allOf": [
        {
          "$ref": "./WebhookConfig.schema.json"
        }
      ]
    },
    "disclosureFrame": {
      "type": "object"
    },
    "vct": {
      "$ref": "./VCT.schema.json"
    },
    "keyBinding": {
      "type": "boolean"
    },
    "keyId": {
      "type": "string"
    },
    "statusManagement": {
      "type": "boolean"
    },
    "lifeTime": {
      "type": "number"
    },
    "schema": {
      "$ref": "./SchemaResponse.schema.json"
    }
  },
  "required": [
    "id",
    "config"
  ]
}